import { render, staticRenderFns } from "./serviceProviderEditDialog.vue?vue&type=template&id=0a4d95fb&"
import script from "./serviceProviderEditDialog.vue?vue&type=script&lang=js&"
export * from "./serviceProviderEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./serviceProviderEditDialog.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports